import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

import { exportAsExcel } from '../../Services/exportAsExcel';

import { fetchApi } from '../../Network/NetworkService';

import '../../Assets/Ui/CohorteClients.css';

import Chart from '../Ui/Chart'
import EnhancedChart from '../Ui/EnhancedChart'

import { getBasePrice } from '../../Services/pricing.js';

const typeStates = [
    { value: 'acne', label: 'acne' },
    { value: 'asthme', label: 'asthme' },
    { value: 'cardiologie', label: 'cardiologie' },
    { value: 'conjonctivite', label: 'conjonctivite' },
    { value: 'contraception', label: 'contraception' },
    { value: 'covid19', label: 'covid19' },
    { value: 'cystite', label: 'cystite' },
    { value: 'dentiste', label: 'dentiste' },
    { value: 'dermatologie,dermatologue-en-ligne', label: 'dermatologie' },
    { value: 'douleurs-de-dos', label: 'douleurs-de-dos' },
    { value: 'dysfonctionnement-erectile', label: 'dysfonctionnement-erectile' },
    { value: 'generaliste,généraliste', label: 'generaliste' },
    { value: 'gynecologie,gynecologue', label: 'gynecologie' },
    { value: 'hemorroides', label: 'hemorroides' },
    { value: 'herpes', label: 'herpes' },
    { value: 'infection urinaire', label: 'infection urinaire' },
    { value: 'kit-voyage-et-vaccination', label: 'kit-voyage-et-vaccination' },
    { value: 'maladie-sexuelle', label: 'maladie-sexuelle' },
    { value: 'ophtalmologie', label: 'ophtalmologie' },
    { value: 'pediatrie', label: 'pediatrie' },
    { value: 'psychologie', label: 'psychologie' },
    { value: 'renouvellement-ordonnance', label: 'renouvellement-ordonnance' },
    { value: 'test-de-grossesse', label: 'test-de-grossesse' },
];

const fromDateToQuarter = (date) => {
    return `${new Date(date).getFullYear()}-${Math.floor(new Date(date).getMonth() / 3 + 1)}`
}

const getMonths = () => {
    let startMonth = 1;
    let startYear = 2020;
    // Include current month in the analysis
    let endMonth = new Date().getMonth() + 1; // getMonth() returns 0-11, so add 1
    let endYear = new Date().getFullYear();

    let months = [];
  
    for(let year = startYear; year <= endYear; year++) {
        let month = year === startYear ? startMonth : 1;
        const monthLimit = year === endYear ? endMonth : 12;
        for(; month <= monthLimit; month++) {
            const input = month < 10 ? `${year}-0${month}` : `${year}-${month}`;
          months.push(input)
        }
      }
      return months;
}

const getQuarter = (isWithSource) => {
    let startQuarter = isWithSource ? 3 : 1;
    let startYear = isWithSource ? 2022 : 2020;
    // Include current quarter in the analysis
    let endQuarter = Math.floor(new Date().getMonth() / 3) + 1;
    let endYear = new Date().getFullYear();
    let result = [];
    for (let year = startYear; year <= endYear; year++) {
        let quarter = year === startYear ? startQuarter : 1;
        const quarterLimit = year === endYear ? endQuarter : 4;
        for(; quarter <= quarterLimit; quarter++) {
            result.push(`${year}-${quarter}`)
        }
    }
    return result;
}
const getDate = (input, h, m, end) => {
    let n;  
    if (input) {
        if (end) {
            n = new Date(Number(input.split('-')[0]), Number(input.split('-')[1]), 0);
        } else {
            n = new Date(`${input.split('-')[0]}/${input.split('-')[1]}/01`);
        }
    } else {
        n = new Date();
    }

    n.setHours(h, m, 0);
    return n.toISOString();
};
const getDateFromQuarter = (input, h, m, end) => {
    let n;
    if (end) {
        n = Number(input.split('-')[1]) === 4 ?  new Date(`${Number(input.split('-')[0]) + 1}/01/01`) : new Date(`${Number(input.split('-')[0])}/${Number(input.split('-')[1]) * 3 + 1}/01`);
    } else {
        n = new Date(`${input.split('-')[0]}/${input.split('-')[1] * 3 - 2}/01`);
    }
    n.setHours(h, m, 0);
    return n.toISOString();
}

const formatDateToMonth = (date) => {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    return `${d.getFullYear()}-${month.toString().padStart(2, '0')}`;
};


const CohorteClients = (props) => {
    const [loading, setLoading] = useState(false);
    const [calculating, setCaculating] = useState(false);
    const [data, setData] = useState({});
    const [input, setInput] = useState('number');
    const [name, setName] = useState('month');
    const [dataType, setDataType] = useState("");
    const [source, setSource] = useState('');
    const [cacheInfo, setCacheInfo] = useState({ cached: false, cacheAge: null, cacheHits: null });
    const [clearingCache, setClearingCache] = useState(false);
    const [visualizationMode, setVisualizationMode] = useState('standard'); // 'standard', 'heatmap', 'percentage'
    const [hoveredCell, setHoveredCell] = useState(null);
    const [countMode, setCountMode] = useState('unique'); // 'unique' for unique users, 'all' for all requests
    const [tableOrientation, setTableOrientation] = useState('vertical'); // 'vertical' or 'horizontal'
    const [showVtHtTable, setShowVtHtTable] = useState(false); // Toggle for VT/HT dedicated tables

    const month = name ==='month' ? getMonths() : getQuarter(source);    

    const clearCache = async () => {
        setClearingCache(true);
        try {
            const response = await fetchApi('/requests/cache/invalidate/all', {
                method: 'DELETE'
            });
            if (response.success) {
                alert('Cache vidé avec succès! Rechargez la page pour obtenir de nouvelles données.');
                // Reload the data after clearing cache
                if (name === 'month') {
                    getDatas();
                } else {
                    getDatasTrimester();
                }
            } else {
                alert('Erreur lors de la suppression du cache');
            }
        } catch (error) {
            console.error('Error clearing cache:', error);
            alert('Erreur lors de la suppression du cache');
        } finally {
            setClearingCache(false);
        }
    };

    const getDatas = () => {
        setLoading(true);
        const month = getMonths();
        const state = ["terminated", "reviewed", "approved", "waiting"];
        
        // Prepare periods for batch request
        const periods = month.map(el => ({
            label: el,
            start: getDate(el, 0, 0, false),
            end: getDate(el, 23, 59, true)
        }));

        // Make single batch request
        fetchApi('/requests/analytics/cohort/batch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                periods: periods,
                state: state,
                type: dataType || null,
                utm_source: source || null
            })
        })
            .then(response => {
                setLoading(false);
                setCaculating(true);
                let datas = {};
                
                if (!response.success) {
                    console.error('Error fetching cohort data:', response.message);
                    setCaculating(false);
                    return;
                }
                
                // Check cache info
                if (response.totalCached > 0) {
                    const cachedResult = response.results.find(r => r.cached);
                    setCacheInfo({ 
                        cached: true, 
                        cacheAge: cachedResult ? cachedResult.cacheAge : 0, 
                        cacheHits: cachedResult ? cachedResult.cacheHits : 0
                    });
                } else {
                    setCacheInfo({ cached: false, cacheAge: null, cacheHits: null });
                }
                
                // Pre-process all requests data into a more efficient structure
                const requestsByMonth = {};
                response.results.forEach((element, index) => {
                    const monthKey = element.period || month[index];
                    requestsByMonth[monthKey] = element.requests;
                });

                // Process each month's data
                response.results.forEach((element, index) => {
                    let userResult = [];  // For unique users
                    let demandeResult = [];  // For all requests
                    let fromNewUser = 0;
                    let turnover = [];
                    
                    const currentMonthDate = getDate(month[index], 0, 0, false);
                    
                    // Pre-filter requests for current month to avoid repeated filtering
                    const currentMonthRequests = element.requests.filter(r => 
                        r.userId && r.createdAt && formatDateToMonth(r.createdAt) === month[index]
                    );
                    
                    for (let i=0; i < month.length; i++) {
                        if (currentMonthDate < getDate(month[i], 0, 0, false)) {
                            userResult.push(null);
                            demandeResult.push(null);
                            turnover.push(null);
                        } else {
                            let calculateTurnover = 0;
                            let countArr;

                            // Filter for specific user creation month
                            if (month[i] === "2020-01") {
                                countArr = currentMonthRequests.filter(r => 
                                    new Date(r.userId?.createdAt) < new Date('2020-01-01') || 
                                    formatDateToMonth(r.userId?.createdAt) === month[i]
                                );
                            } else {
                                countArr = currentMonthRequests.filter(r => 
                                    formatDateToMonth(r.userId?.createdAt) === month[i]
                                );
                            }
                            
                            // Calculate unique users
                            let uniqueUsers = [];
                            const userIdSet = new Set();
                            countArr.forEach(item => {
                                if (!userIdSet.has(item.userId._id)) {
                                    userIdSet.add(item.userId._id);
                                    uniqueUsers.push(item);
                                }
                            });
                            
                            // Store both counts
                            const uniqueCount = uniqueUsers.length;
                            const totalCount = countArr.length;
                            
                            // Calculate turnover based on unique users
                            uniqueUsers.forEach(el => {
                                calculateTurnover += getBasePrice(el.type);
                            });

                            userResult.push(uniqueCount);
                            demandeResult.push(totalCount);
                            turnover.push(calculateTurnover);
                            
                            if (i === index) {
                                fromNewUser = countMode === 'all' ? totalCount : uniqueCount;
                            }
                        }
                    };
                    // Standardize data structure with quarterly view
                    datas[month[index]] = {
                        result: countMode === 'all' ? demandeResult : userResult, // Use countMode to select
                        userResult,  // Always unique users
                        demandeResult,  // Always all requests
                        total: fromNewUser, 
                        turnover
                    };
                });
                setCaculating(false);
                setData(datas);
                setName('month');
            })
            .catch(err => {
                setLoading(false);
                console.error(err);
            })
    };

    const getDatasTrimester = () => {
        setLoading(true);
        const month = getQuarter(source);
        const state = ["terminated", "reviewed", "approved", "waiting"];
        
        // Prepare periods for batch request
        const periods = month.map(el => ({
            label: el,
            start: getDateFromQuarter(el, 0, 0, false),
            end: getDateFromQuarter(el, 0, 0, true)
        }));

        // Make single batch request
        fetchApi('/requests/analytics/cohort/batch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                periods: periods,
                state: state,
                type: dataType || null,
                utm_source: source || null
            })
        })
            .then(response => {
                setLoading(false);
                setCaculating(true);
                let datas = {};
                
                if (!response.success) {
                    console.error('Error fetching cohort data:', response.message);
                    setCaculating(false);
                    return;
                }
                
                // Check cache info
                if (response.totalCached > 0) {
                    const cachedResult = response.results.find(r => r.cached);
                    setCacheInfo({ 
                        cached: true, 
                        cacheAge: cachedResult ? cachedResult.cacheAge : 0, 
                        cacheHits: cachedResult ? cachedResult.cacheHits : 0
                    });
                } else {
                    setCacheInfo({ cached: false, cacheAge: null, cacheHits: null });
                }
                
                // Process each quarter's data with optimizations
                response.results.forEach((element, index) => {
                    let userResult = [];
                    let demandeResult = [];
                    let fromNewUser = 0;
                    let turnover = [];
                    
                    const currentQuarterDate = getDateFromQuarter(month[index], 0, 0, false);
                    
                    // Pre-filter requests for current quarter to avoid repeated filtering
                    const currentQuarterRequests = element.requests.filter(r => 
                        r.userId && r.createdAt && fromDateToQuarter(r.createdAt) === month[index]
                    );
                    
                    for (let i=0; i < month.length; i++) {
                        if (currentQuarterDate < getDateFromQuarter(month[i], 0, 0, false)) {
                            userResult.push(null);
                            demandeResult.push(null);
                            turnover.push(null);
                        } else {
                            let calculateTurnover = 0;
                            let countArr;

                            // Filter for specific user creation quarter
                            if (month[i] === "2020-1") {
                                countArr = currentQuarterRequests.filter(r => 
                                    new Date(r.userId?.createdAt) < new Date('2020-01-01') || 
                                    fromDateToQuarter(r.userId?.createdAt) === month[i]
                                );
                            } else {
                                countArr = currentQuarterRequests.filter(r => 
                                    fromDateToQuarter(r.userId?.createdAt) === month[i]
                                );
                            }

                            // Use a Set for O(1) deduplication instead of O(n²) findIndex
                            const userIdSet = new Set();
                            const uniqueArr = [];
                            countArr.forEach(item => {
                                if (!userIdSet.has(item.userId._id)) {
                                    userIdSet.add(item.userId._id);
                                    uniqueArr.push(item);
                                }
                            });
                            
                            const count = uniqueArr.length;
                            // Calculate turnover based on unique users for consistency
                            uniqueArr.forEach(el => {
                                calculateTurnover += getBasePrice(el.type);
                            });

                            userResult.push(uniqueArr.length);
                            demandeResult.push(countArr.length)
                            turnover.push(calculateTurnover)
                            if (getDateFromQuarter(month[index], 0, 0, false) === getDateFromQuarter(month[i], 0, 0, false)) {
                                fromNewUser = countMode === 'all' ? countArr.length : uniqueArr.length;
                            }
                        }
                    };
                    // Standardize data structure
                    datas[month[index]] = {
                        result: countMode === 'all' ? demandeResult : userResult, // Use countMode instead of dataType
                        userResult, 
                        demandeResult, 
                        total: fromNewUser, 
                        turnover
                    };
                });
                setCaculating(false);
                setData(datas);
                setName('trimester')
            })
            .catch(err => {
                setLoading(false);
                console.error(err);
            })
    };

    useEffect(()=> {
        if (name === "month") {
            getDatas();
        } else {
            getDatasTrimester();
        }

    }, [dataType, source, countMode]);

    const exportToExcel = () => {

            let toExport = month?.map( (m,i) => {
                let obj = {"Nombre de consultation": m};
                data[m] && data[m].demandeResult.forEach((el, i) => obj[month[i]] = el);
                obj['Consultation mois N'] = data[m].demandeResult.filter(val => val !== null).reduce((acc, val) => acc + val, 0);

                obj['']= ''


                obj['Nombre de nouveau client']= m;

                data[m] && data[m].userResult.forEach((el, i) => obj[`${month[i]} `] = el);
                obj['Client mois N'] = data[m].userResult.filter(val => val !== null).reduce((acc, val) => acc + val, 0);

                return obj;
            });
    
            let total = {'Nombre de consultation': 'Total'};
            Object.keys(data).length === month.length && month.map((m, i) => total[month[i]] = Object.keys(data).map(d => data[d].demandeResult[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0) );
            total['Consultation mois N'] = Object.keys(data).length === month.length && month.map((m, i) => Object.keys(data).map(d => data[d].demandeResult[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0)).reduce((acc, val) => acc+val, 0);


            total["Nombre de nouveau client"] = 'Total';
            Object.keys(data).length === month.length && month.map((m, i) => total[`${month[i]} `] = Object.keys(data).map(d => data[d].userResult[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0) );
            total['Client mois N'] = Object.keys(data).length === month.length && month.map((m, i) => Object.keys(data).map(d => data[d].userResult[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0)).reduce((acc, val) => acc+val, 0);
        
            toExport.push(total);
    
            let totalPerMonth = {'Nombre de consultation': 'Part des clients inscrits en mois N'};
            Object.keys(data).length === month.length && month.map((m, i) => {
                const totalDemandeResult = Object.keys(data).map(d => data[d].demandeResult[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0);
                const baseTotal = data[m].total || 1;
                totalPerMonth[month[i]] = `${((totalDemandeResult - data[m].total) / baseTotal * 100).toFixed(2)} %`;
            });
            totalPerMonth['Consultation mois N'] = Object.keys(data).length === month.length && month.map(el => data[el].total).reduce( (acc, val) => acc + val, 0);

            totalPerMonth["Nombre de nouveau client"] = "Part des clients inscrits en mois N";
            Object.keys(data).length === month.length && month.map((m, i) => {
                const totalUserResult = Object.keys(data).map(d => data[d].userResult[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0);
                const baseTotal = data[m].total || 1;
                totalPerMonth[`${month[i]} `] = `${((totalUserResult - data[m].total) / baseTotal * 100).toFixed(2)} %`;
            });
            totalPerMonth['Client mois N'] = Object.keys(data).length === month.length && month.map(el => data[el].total).reduce( (acc, val) => acc + val, 0);

            toExport.push(totalPerMonth);

            toExport.push({'': ''})
            toExport.push({'': ''})
            toExport.push({'': ''})


            let titre = {"Nombre de consultation": "", "Consultation mois N" : "Récurrentes"};
            month.map(m => titre[m] = m);
            toExport.push(titre)

            let cohortTable = month?.map( (m,index) => {
                let obj= {"Nombre de consultation": m}
                let sum = 0
                data[m] && data[m].demandeResult.forEach((el, i) => {
                    if (el) {
                        obj[month[i]] = `${obj[month[i]] = (Math.ceil((el/data[m].userResult[index])*100))}%`;
                        sum += Math.ceil((el/data[m].userResult[index])*100)
                    } else if ( el === 0) {
                        obj[month[i]] = "0%"
                    } else {
                        obj[month[i]] = null
                    }
                    
                });
                obj['Consultation mois N'] = `${sum - 100}%`;

                return obj;
            });
            
        
            toExport = [...toExport,...cohortTable]
         
            toExport.push({'': ''})
            toExport.push({'': ''})
            toExport.push({'': ''})

            let title = {"Nombre de consultation": "Récurente"};
            month.map(m => title[m] = m);

            title["Nombre de nouveau client"] = "Récurente Cumulée";
            month.map(m => title[`${m} `] = m);
            toExport.push(title);

            let pourcentCohortTable = month.map( (m,index) => {
                let cohortObj= {"Nombre de consultation": m}

                const keys = [...month]
                const values = cohortTable.map(el => el[m]).filter(el => el)
                keys.map((key,i) => cohortObj[key] = values[i])

                // cohortObj['Consultation mois N'] = '';

                // cohortObj['']= ''

                let cohortCumulateObj = {'Nombre de nouveau client' : m}

                let sum = 0;
                
                let periods = Object.keys(cohortObj).filter(key => key && key !== "Nombre de consultation" && key !== "Consultation mois N");
                
                periods.forEach(period => {
                    if (cohortObj[period]) {
                        sum += parseInt(cohortObj[period], 10); 
                        cohortCumulateObj[`${period} `] = `${sum} %`; 
                    }
                  
                });

                return {...cohortObj, ...cohortCumulateObj};
            });

            toExport = [...toExport,...pourcentCohortTable]

    
            const cls = month.map(el => ({ wch: 10 })); 
         
            exportAsExcel(toExport, `cohorte-client`, cls);  
         
    }

    // Helper function to get color class based on retention percentage
    const getRetentionColorClass = (value, baseValue) => {
        if (!value || !baseValue || baseValue === 0) return 'retention-0';
        const percentage = (value / baseValue) * 100;
        if (percentage === 0) return 'retention-0';
        if (percentage <= 10) return 'retention-1';
        if (percentage <= 20) return 'retention-2';
        if (percentage <= 30) return 'retention-3';
        if (percentage <= 40) return 'retention-4';
        if (percentage <= 50) return 'retention-5';
        if (percentage <= 60) return 'retention-6';
        if (percentage <= 70) return 'retention-7';
        if (percentage <= 80) return 'retention-8';
        if (percentage <= 90) return 'retention-9';
        return 'retention-10';
    };

    // Helper function to format cell value based on visualization mode
    const formatCellValue = (value, baseValue, mode) => {
        if (value === null || value === undefined) return '';

        switch (mode) {
            case 'percentage':
                if (!baseValue || baseValue === 0) return '0%';
                return `${Math.round((value / baseValue) * 100)}%`;
            case 'heatmap':
                return value;
            default:
                return value;
        }
    };

    // Helper function to get background color based on value intensity
    const getValueColor = (value, maxValue) => {
        if (!value || !maxValue || maxValue === 0) return '#f0f0f0';
        const intensity = (value / maxValue);
        const hue = 200; // Blue hue
        const saturation = 70;
        const lightness = 95 - (intensity * 45); // From light to darker
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    return (
        <div className='cohorte'>
            {cacheInfo.cached && (
                <div className="cache-indicator">
                    <span className="cache-badge">Données en cache</span>
                    <span className="cache-details">
                        Âge du cache: {Math.floor(cacheInfo.cacheAge / 60)} minutes | 
                        Nombre d'accès: {cacheInfo.cacheHits}
                    </span>
                </div>
            )}
            <Modal
                show={loading || calculating}
                backdrop="static"
                keyboard={false}
                size="lg"
                className="modal-spinner"
            >
                <span className="loader" />
                {loading && <p>Récupération des données en cours...</p>}
                {calculating && <p>Calcul des données en cours...</p>}
            </Modal>

            <select name='name' value={name} onChange={e=>{
                if (e.target.value === 'month') {
                    getDatas();
                };
                if (e.target.value === 'trimester') {
                    getDatasTrimester();
                };
            }}>
                <option value='month'>Par mois</option>
                <option value='trimester'>Par trimestre</option>
            </select>

            <select name='countMode' value={countMode} onChange={(e)=>{
                setCountMode(e.target.value);
            }} style={{ backgroundColor: countMode === 'unique' ? '#d4edda' : '#f8d7da' }}>
                <option value='unique'>Clients uniques</option>
                <option value='all'>Toutes les consultations</option>
            </select>

            <select name='dataType' value={dataType} onChange={(e)=>{
                setDataType(e.target.value)
            }}>
                <option value=''>Tous les pathologies</option>
                {
                    typeStates.map(type => <option value={type.value} key={type.value}>{type.label}</option>)
                }
            </select>
            <select name='source' value={source} onChange={e=>{
                setSource(e.target.value);
            }}>
                <option value=''>Tous les sources</option>
                <option value='google'>Google</option>
                <option value='skycall'>Skycall</option>
                <option value='amezian'>Amezian</option>
                <option value='chatgpt'>Chatgpt</option>
                <option value='infirmiers'>Infirmiers</option>
                <option value='null'>Naturel</option>
            </select>
            <select name='input' value={input} onChange={e=>{
                setInput(e.target.value);
            }}>
                <option value='number'>Nombre</option>
                <option value='percent'>Pourcentage</option>
                <option value='turnover'>Chiffre d'affaire</option>
                <option value='chart'>Graphique</option>
            </select>

            {input !== "chart" && <button onClick={() => exportToExcel()} className ='button'>Export en excel</button>}
            <button onClick={clearCache} disabled={clearingCache} className='button' style={{marginLeft: '10px'}}>
                {clearingCache ? 'Suppression...' : 'Vider le cache'}
            </button>

            {input !== "chart" && (
                <div className="visualization-toggle">
                    <button
                        className={visualizationMode === 'standard' ? 'active' : ''}
                        onClick={() => setVisualizationMode('standard')}
                    >
                        Standard
                    </button>
                    <button
                        className={visualizationMode === 'heatmap' ? 'active' : ''}
                        onClick={() => setVisualizationMode('heatmap')}
                    >
                        Heatmap
                    </button>
                    <button
                        className={visualizationMode === 'percentage' ? 'active' : ''}
                        onClick={() => setVisualizationMode('percentage')}
                    >
                        Pourcentage
                    </button>
                </div>
            )}

            {input !== "chart" && (
                <div className="visualization-toggle" style={{marginTop: '10px'}}>
                    <button
                        className={tableOrientation === 'vertical' ? 'active' : ''}
                        onClick={() => setTableOrientation('vertical')}
                    >
                        Vue verticale
                    </button>
                    <button
                        className={tableOrientation === 'horizontal' ? 'active' : ''}
                        onClick={() => setTableOrientation('horizontal')}
                    >
                        Comptage horizontal
                    </button>
                </div>
            )}

            {input !== "chart" && tableOrientation === 'vertical' && (
                <div className="visualization-toggle" style={{marginTop: '10px'}}>
                    <button
                        className={showVtHtTable ? 'active' : ''}
                        onClick={() => setShowVtHtTable(!showVtHtTable)}
                    >
                        {showVtHtTable ? 'Masquer' : 'Afficher'} Tableaux VT/HT
                    </button>
                </div>
            )}

            {
                input === "chart" ?
                <EnhancedChart
                    months={month}
                    data={data}
                    dataType={dataType}
                    countMode={countMode}
                />
                :
                tableOrientation === 'vertical' ?
                <div className='table-container'>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                {
                                    month.map(el =>
                                    <th key={`h-${el}`}>
                                        {el}
                                    </th>)
                                }
                                { input === "number" && <th>{countMode === 'all' ? 'Consultations mois N' : 'Clients uniques mois N'}</th> }
                                { input === "percent" && <th>CAHT Mensuel</th> }
                                { input === "turnover" && <th>CA</th> }
                                { input === "turnover" && <th>CA Récurrents</th> }
                            </tr>
                        </thead>
                        <tbody>
                            {(() => {
                                // Pre-calculate vertical totals (VT) for each column
                                const verticalTotals = {};
                                // Pre-calculate horizontal totals (HT) for each row
                                const horizontalTotals = {};

                                // Calculate VT - For each column (per cohort: exclude diagonal, accumulate from next row)
                                if (month.length > 0 && data[month[0]]) {
                                    const numColumns = data[month[0]].result.length;

                                    for (let colIndex = 0; colIndex < numColumns; colIndex++) {
                                        let cumulativeVT = 0;

                                        // Go through each row (month) for this column
                                        month.forEach((rowMonth, rowIndex) => {
                                            if (data[rowMonth]) {
                                                const value = input === "turnover" ? data[rowMonth].turnover[colIndex] : data[rowMonth].result[colIndex];

                                                // Diagonal cell (first month of this cohort): Exclude from VT
                                                if (rowIndex === colIndex) {
                                                    verticalTotals[`${rowMonth}-${colIndex}`] = null;
                                                }
                                                // Second row onwards (first recurrence): Show cumulative VT
                                                else if (rowIndex > colIndex && value !== null) {
                                                    cumulativeVT += value;
                                                    verticalTotals[`${rowMonth}-${colIndex}`] = cumulativeVT;
                                                } else {
                                                    verticalTotals[`${rowMonth}-${colIndex}`] = null;
                                                }
                                            }
                                        });
                                    }
                                }

                                // Calculate HT - For each row
                                month.forEach((rowMonth) => {
                                    if (data[rowMonth]) {
                                        const values = input === "turnover" ? data[rowMonth].turnover : data[rowMonth].result;
                                        let cumulativeHT = 0;
                                        let startedAccumulating = false;

                                        values.forEach((value, colIndex) => {
                                            if (value !== null) {
                                                if (!startedAccumulating) {
                                                    cumulativeHT = value;
                                                    startedAccumulating = true;
                                                    horizontalTotals[`${rowMonth}-${colIndex}`] = null; // First value, no HT
                                                } else {
                                                    cumulativeHT += value;
                                                    horizontalTotals[`${rowMonth}-${colIndex}`] = cumulativeHT;
                                                }
                                            } else {
                                                horizontalTotals[`${rowMonth}-${colIndex}`] = null;
                                            }
                                        });
                                    }
                                });

                                return month.map(el =>
                                    <tr key={`v-${el}`}>
                                        <td className='first-column'><b>{el}</b></td>
                                        {data[el] && input === "number" && data[el].result.map((item, i) => {
                                            const cellValue = formatCellValue(item, data[el].total, visualizationMode);
                                            const colorClass = visualizationMode === 'heatmap' ? getRetentionColorClass(item, data[el].total) : '';
                                            const vt = verticalTotals[`${el}-${i}`];
                                            const ht = horizontalTotals[`${el}-${i}`];

                                            // Calculate VTP: (VT × 100) / Row 0 value
                                            let vtp = null;
                                            if (vt !== null && data[month[i]]) {
                                                const row0Value = data[month[i]].result[i]; // Diagonal value for this cohort
                                                if (row0Value && row0Value > 0) {
                                                    vtp = ((vt * 100) / row0Value).toFixed(2);
                                                }
                                            }

                                            return (
                                                <td
                                                    key={`item-${i}`}
                                                    className={`${visualizationMode === 'heatmap' ? 'heatmap-cell ' + colorClass : ''}`}
                                                    onMouseEnter={(e) => setHoveredCell({ row: el, col: i, value: item, total: data[el].total, e })}
                                                    onMouseLeave={() => setHoveredCell(null)}
                                                >
                                                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                                                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{cellValue}</div>
                                                        {vt !== null && item !== null && (
                                                            <div style={{fontSize: '11px', color: '#2563eb', backgroundColor: '#dbeafe', padding: '2px 4px', borderRadius: '3px'}}>VT: {vt}</div>
                                                        )}
                                                        {vtp !== null && item !== null && (
                                                            <div style={{fontSize: '11px', color: '#7c3aed', backgroundColor: '#ede9fe', padding: '2px 4px', borderRadius: '3px'}}>VTP: {vtp}%</div>
                                                        )}
                                                        {/* {ht !== null && item !== null && (
                                                            <div style={{fontSize: '11px', color: '#059669', backgroundColor: '#d1fae5', padding: '2px 4px', borderRadius: '3px'}}>HT: {ht}</div>
                                                        )} */}
                                                    </div>
                                                </td>
                                            );
                                        })}
                                        {data[el] && input === "percent" && data[el].result.map((item, i) => {
                                            const baseTotal = data[month[i]]?.total || 1;
                                            const vt = verticalTotals[`${el}-${i}`];
                                            const ht = horizontalTotals[`${el}-${i}`];

                                            // Calculate VTP: (VT × 100) / Row 0 value
                                            let vtp = null;
                                            if (vt !== null && data[month[i]]) {
                                                const row0Value = data[month[i]].result[i]; // Diagonal value for this cohort
                                                if (row0Value && row0Value > 0) {
                                                    vtp = ((vt * 100) / row0Value).toFixed(2);
                                                }
                                            }

                                            return item !== null ? (
                                                <td key={`item-${i}`}>
                                                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                                                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{(item / baseTotal * 100).toFixed(2)} %</div>
                                                        {vt !== null && (
                                                            <div style={{fontSize: '11px', color: '#2563eb', backgroundColor: '#dbeafe', padding: '2px 4px', borderRadius: '3px'}}>VT: {vt}</div>
                                                        )}
                                                        {vtp !== null && (
                                                            <div style={{fontSize: '11px', color: '#7c3aed', backgroundColor: '#ede9fe', padding: '2px 4px', borderRadius: '3px'}}>VTP: {vtp}%</div>
                                                        )}
                                                        {/* {ht !== null && (
                                                            <div style={{fontSize: '11px', color: '#059669', backgroundColor: '#d1fae5', padding: '2px 4px', borderRadius: '3px'}}>HT: {ht}</div>
                                                        )} */}
                                                    </div>
                                                </td>
                                            ) : <td key={`k-${i}`}></td>;
                                        })}
                                        {data[el] && input === "turnover" && data[el].turnover.map((item, i) => {
                                            const vt = verticalTotals[`${el}-${i}`];
                                            const ht = horizontalTotals[`${el}-${i}`];

                                            // Calculate VTP: (VT × 100) / Row 0 value
                                            let vtp = null;
                                            if (vt !== null && data[month[i]]) {
                                                const row0Value = data[month[i]].turnover[i]; // Diagonal value for this cohort
                                                if (row0Value && row0Value > 0) {
                                                    vtp = ((vt * 100) / row0Value).toFixed(2);
                                                }
                                            }

                                            return item !== null ? (
                                                <td key={`item-${i}`}>
                                                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                                                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{item} €</div>
                                                        {vt !== null && (
                                                            <div style={{fontSize: '11px', color: '#2563eb', backgroundColor: '#dbeafe', padding: '2px 4px', borderRadius: '3px'}}>VT: {vt} €</div>
                                                        )}
                                                        {vtp !== null && (
                                                            <div style={{fontSize: '11px', color: '#7c3aed', backgroundColor: '#ede9fe', padding: '2px 4px', borderRadius: '3px'}}>VTP: {vtp}%</div>
                                                        )}
                                                        {/* {ht !== null && (
                                                            <div style={{fontSize: '11px', color: '#059669', backgroundColor: '#d1fae5', padding: '2px 4px', borderRadius: '3px'}}>HT: {ht} €</div>
                                                        )} */}
                                                    </div>
                                                </td>
                                            ) : <td key={`k-${i}`}></td>;
                                        })}          
                                        {!data[el] && month.map(el=><td key={`e-${el}`}></td>)}

                                        {data[el] && input === "number" && <td><b>{data[el].result.filter(val => val !== null).reduce((acc, val) => acc + val, 0)}</b></td>}
                                        {data[el] && input === "percent" && <td><b>{(data[el].result.map((item, i) => {
                                            const baseTotal = data[month[i]]?.total || 1;
                                            return item !== null ? (item / baseTotal * 100).toFixed(2) : 0;
                                        }).reduce((acc, val) => acc + Number(val), 0)).toFixed(2)} % </b></td>}
                                        {data[el] && input === "turnover" && <td><b>{data[el].turnover.filter(val => val !== null).reduce((acc, val) => acc + val, 0)}</b> euros</td>}
                                        {data[el] && input === "turnover" && <td><b>{data[el].turnover.filter(val => val !== null).reduce((acc, val) => acc + val, 0) - Math.max(...data[el].turnover.filter(element=>element !== null))}</b> <br/> euros</td>}
                                        {!data[el] && <td></td>}
                                    </tr>
                                );
                            })()}
                            {
                                input === "number" &&
                                <tr>
                                    <td>Total</td>
                                    {Object.keys(data).length === month.length && month.map((m, i) => <td key={`total-${i}`}>{Object.keys(data).map(d => data[d].result[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0)}</td> )}
                                    {Object.keys(data).length === month.length && <td><b>{month.map((m, i) => Object.keys(data).map(d => data[d].result[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0) ).reduce((acc, val) => acc+val, 0)}</b></td>}
                                </tr>
                            }

                            {
                                input === "percent" &&
                                <tr>
                                <td>Nombre de Clients inscrits en mois N</td>
                                {Object.keys(data).length === month.length && month.map((m, i) => {
                                    const totalResult = Object.keys(data).map(d => data[d].result[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0);
                                    const baseTotal = data[m]?.total || 1;
                                    return <td key={`percent-${i}`}>{((totalResult - data[m].total) / baseTotal * 100).toFixed(2)} %</td>;
                                })}
                                {Object.keys(data).length === month.length && <td><b>{month.map((m, i) => {
                                    const totalResult = Object.keys(data).map(d => data[d].result[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0);
                                    const baseTotal = data[m]?.total || 1;
                                    return (totalResult - data[m].total) / baseTotal * 100;
                                }).reduce((acc, val) => acc+val, 0).toFixed(2)} %</b></td>}
                            </tr>
                            }
                    
                            {
                                input === "number" &&
                                <tr>
                                <td>Part des clients inscrits en mois N</td>
                                {
                                    Object.keys(data).length === month.length && month.map(el => {
                                        const totalResult = data[el]?.result.filter(val => val !== null).reduce((acc, val) => acc + val, 0) || 1;
                                        return data[el] && <td key={`part-${el}`}>{(data[el].total / totalResult * 100).toFixed(2)} %</td>;
                                    })
                                }
                                <td><b>{ Object.keys(data).length === month.length && month.map(el => data[el].total).reduce( (acc, val) => acc + val, 0)}</b></td>
                            </tr>
                            }

                            {
                                input === "turnover" &&
                                <tr>
                                    <td>Total</td>
                                    {Object.keys(data).length === month.length && month.map((m, i) => <td key={`turnover-${i}`}>{Object.keys(data).map(d => data[d].turnover[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0)} euros</td> )}
                                    {Object.keys(data).length === month.length && <td><b>{month.map((m, i) => Object.keys(data).map(d => data[d].turnover[i]).filter(val => val !== null).reduce( (acc, val) => acc+val, 0) ).reduce((acc, val) => acc+val, 0)}</b> <br/>euros</td>}
                                    {Object.keys(data).length === month.length && <td><b>{month.map((m, i) => {
                                        const filteredTurnover = data[m].turnover.filter(element => element !== null);
                                        const totalTurnover = filteredTurnover.reduce((acc, val) => acc + val, 0);
                                        const maxTurnover = filteredTurnover.length > 0 ? Math.max(...filteredTurnover) : 0;
                                        return totalTurnover - maxTurnover;
                                    }).reduce((acc, val) => acc + val, 0)}</b> <br/> euros</td>}
                                </tr>
                            }

                        </tbody>
                    </table>
                </div>
                :
                <div className='table-container'>
                    <table>
                        <thead>
                            <tr>
                                <th>Période</th>
                                {
                                    month.map(cohort =>
                                    <th key={`h-cohort-${cohort}`}>
                                        {cohort}
                                    </th>)
                                }
                                <th>Total Période</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                month.map((period, periodIndex) => {
                                    const periodData = month.map(cohort => {
                                        if (!data[cohort]) return null;
                                        const cohortIndex = month.indexOf(cohort);
                                        if (periodIndex < cohortIndex) return null;
                                        return data[cohort].result[periodIndex];
                                    });

                                    const periodTotal = periodData.reduce((acc, val) => {
                                        if (val === null) return acc;
                                        return acc + val;
                                    }, 0);

                                    return (
                                        <tr key={`h-period-${period}`}>
                                            <td className='first-column'><b>{period}</b></td>
                                            {
                                                periodData.map((value, idx) => {
                                                    if (value === null) {
                                                        return <td key={`empty-${idx}`} style={{background: '#f0f0f0'}}></td>;
                                                    }

                                                    if (input === "number") {
                                                        return <td key={`val-${idx}`}>{value}</td>;
                                                    }
                                                    if (input === "percent") {
                                                        const cohort = month[idx];
                                                        const cohortTotal = data[cohort]?.total || 1;
                                                        return <td key={`val-${idx}`}>{(value / cohortTotal * 100).toFixed(2)} %</td>;
                                                    }
                                                    if (input === "turnover") {
                                                        const turnoverValue = data[month[idx]]?.turnover[periodIndex];
                                                        return <td key={`val-${idx}`}>{turnoverValue !== null ? `${turnoverValue} euros` : ''}</td>;
                                                    }
                                                    return <td key={`val-${idx}`}>{value}</td>;
                                                })
                                            }
                                            <td><b>{input === "turnover" ? `${periodTotal} euros` : periodTotal}</b></td>
                                        </tr>
                                    );
                                })
                            }
                            <tr>
                                <td><b>Total Cohorte</b></td>
                                {
                                    month.map(cohort => {
                                        if (!data[cohort]) return <td key={`total-${cohort}`}>0</td>;
                                        const total = input === "turnover"
                                            ? data[cohort].turnover.filter(val => val !== null).reduce((acc, val) => acc + val, 0)
                                            : data[cohort].result.filter(val => val !== null).reduce((acc, val) => acc + val, 0);
                                        return <td key={`total-${cohort}`}><b>{input === "turnover" ? `${total} euros` : total}</b></td>;
                                    })
                                }
                                <td><b>
                                    {
                                        input === "turnover"
                                            ? `${Object.keys(data).reduce((acc, cohort) => acc + data[cohort].turnover.filter(v => v !== null).reduce((a, v) => a + v, 0), 0)} euros`
                                            : Object.keys(data).reduce((acc, cohort) => acc + data[cohort].result.filter(v => v !== null).reduce((a, v) => a + v, 0), 0)
                                    }
                                </b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }

            {/* VT/HT Tables */}
            {input !== "chart" && tableOrientation === 'vertical' && showVtHtTable && Object.keys(data).length > 0 && (
                <div style={{marginTop: '40px'}}>
                    <h3 style={{marginBottom: '20px'}}>Totaux Verticaux (VT) et VTP par Mois</h3>

                    {/* VT Table */}
                    <div className='table-container' style={{marginBottom: '30px'}}>
                        <h4 style={{marginBottom: '10px', color: '#666'}}>Totaux Verticaux (VT) - Cumul par colonne</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    {month.map(el => <th key={`vt-h-${el}`}>{el}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    // Calculate VT for each column (per cohort: exclude diagonal, accumulate from next row)
                                    const verticalTotals = {};
                                    const maxVtPerColumn = {};

                                    if (month.length > 0 && data[month[0]]) {
                                        const numColumns = data[month[0]].result.length;

                                        for (let colIndex = 0; colIndex < numColumns; colIndex++) {
                                            let cumulativeVT = 0;
                                            let maxVt = 0;

                                            month.forEach((rowMonth, rowIndex) => {
                                                if (data[rowMonth]) {
                                                    const value = input === "turnover" ? data[rowMonth].turnover[colIndex] : data[rowMonth].result[colIndex];

                                                    // Diagonal cell (first month of this cohort): Exclude from VT
                                                    if (rowIndex === colIndex) {
                                                        verticalTotals[`${rowMonth}-${colIndex}`] = null;
                                                    }
                                                    // Second row onwards (first recurrence): Show cumulative VT
                                                    else if (rowIndex > colIndex && value !== null) {
                                                        cumulativeVT += value;
                                                        verticalTotals[`${rowMonth}-${colIndex}`] = cumulativeVT;
                                                        if (cumulativeVT > maxVt) maxVt = cumulativeVT;
                                                    } else {
                                                        verticalTotals[`${rowMonth}-${colIndex}`] = null;
                                                    }
                                                }
                                            });
                                            maxVtPerColumn[colIndex] = maxVt;
                                        }
                                    }

                                    return month.map(el =>
                                        <tr key={`vt-row-${el}`}>
                                            <td className='first-column'><b>{el}</b></td>
                                            {data[el] && data[el].result.map((item, i) => {
                                                const vt = verticalTotals[`${el}-${i}`];
                                                const bgColor = vt !== null ? getValueColor(vt, maxVtPerColumn[i]) : '#f0f0f0';
                                                return (
                                                    <td key={`vt-${i}`} style={{backgroundColor: bgColor, fontWeight: vt !== null ? 'bold' : 'normal'}}>
                                                        {vt !== null ? (input === "turnover" ? `${vt} €` : vt) : '-'}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })()}
                            </tbody>
                        </table>
                    </div>

                    {/* VTP Table */}
                    <div className='table-container' style={{marginBottom: '30px'}}>
                        <h4 style={{marginBottom: '10px', color: '#7c3aed'}}>Totaux Verticaux en Pourcentage (VTP) - (VT × 100) / Row 0</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    {month.map(el => <th key={`vtp-h-${el}`}>{el}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    // Calculate VT and VTP for each column
                                    const verticalTotals = {};
                                    const verticalTotalPercentages = {};
                                    const maxVtpPerColumn = {};

                                    if (month.length > 0 && data[month[0]]) {
                                        const numColumns = data[month[0]].result.length;

                                        for (let colIndex = 0; colIndex < numColumns; colIndex++) {
                                            let cumulativeVT = 0;
                                            let maxVtp = 0;
                                            const row0Value = input === "turnover" ? data[month[colIndex]].turnover[colIndex] : data[month[colIndex]].result[colIndex];

                                            month.forEach((rowMonth, rowIndex) => {
                                                if (data[rowMonth]) {
                                                    const value = input === "turnover" ? data[rowMonth].turnover[colIndex] : data[rowMonth].result[colIndex];

                                                    // Diagonal cell (first month of this cohort): Exclude from VTP
                                                    if (rowIndex === colIndex) {
                                                        verticalTotals[`${rowMonth}-${colIndex}`] = null;
                                                        verticalTotalPercentages[`${rowMonth}-${colIndex}`] = null;
                                                    }
                                                    // Second row onwards (first recurrence): Show cumulative VTP
                                                    else if (rowIndex > colIndex && value !== null) {
                                                        cumulativeVT += value;
                                                        verticalTotals[`${rowMonth}-${colIndex}`] = cumulativeVT;

                                                        // Calculate VTP
                                                        if (row0Value && row0Value > 0) {
                                                            const vtp = ((cumulativeVT * 100) / row0Value);
                                                            verticalTotalPercentages[`${rowMonth}-${colIndex}`] = vtp;
                                                            if (vtp > maxVtp) maxVtp = vtp;
                                                        } else {
                                                            verticalTotalPercentages[`${rowMonth}-${colIndex}`] = null;
                                                        }
                                                    } else {
                                                        verticalTotals[`${rowMonth}-${colIndex}`] = null;
                                                        verticalTotalPercentages[`${rowMonth}-${colIndex}`] = null;
                                                    }
                                                }
                                            });
                                            maxVtpPerColumn[colIndex] = maxVtp;
                                        }
                                    }

                                    return month.map(el =>
                                        <tr key={`vtp-row-${el}`}>
                                            <td className='first-column'><b>{el}</b></td>
                                            {data[el] && data[el].result.map((item, i) => {
                                                const vtp = verticalTotalPercentages[`${el}-${i}`];
                                                const bgColor = vtp !== null ? getValueColor(vtp, maxVtpPerColumn[i]) : '#f0f0f0';
                                                return (
                                                    <td key={`vtp-${i}`} style={{backgroundColor: bgColor, fontWeight: vtp !== null ? 'bold' : 'normal'}}>
                                                        {vtp !== null ? `${vtp.toFixed(2)}%` : '-'}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })()}
                            </tbody>
                        </table>
                    </div>

                    {/* HT Table */}
                    {/* <div className='table-container'>
                        <h4 style={{marginBottom: '10px', color: '#999'}}>Totaux Horizontaux (HT) - Cumul par ligne</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    {month.map(el => <th key={`ht-h-${el}`}>{el}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    // Calculate HT for each row
                                    const horizontalTotals = {};
                                    const maxHtPerRow = {};

                                    month.forEach((rowMonth) => {
                                        if (data[rowMonth]) {
                                            const values = input === "turnover" ? data[rowMonth].turnover : data[rowMonth].result;
                                            let cumulativeHT = 0;
                                            let startedAccumulating = false;
                                            let maxHt = 0;

                                            values.forEach((value, colIndex) => {
                                                if (value !== null) {
                                                    if (!startedAccumulating) {
                                                        cumulativeHT = value;
                                                        startedAccumulating = true;
                                                        horizontalTotals[`${rowMonth}-${colIndex}`] = null;
                                                    } else {
                                                        cumulativeHT += value;
                                                        horizontalTotals[`${rowMonth}-${colIndex}`] = cumulativeHT;
                                                        if (cumulativeHT > maxHt) maxHt = cumulativeHT;
                                                    }
                                                } else {
                                                    horizontalTotals[`${rowMonth}-${colIndex}`] = null;
                                                }
                                            });
                                            maxHtPerRow[rowMonth] = maxHt;
                                        }
                                    });

                                    return month.map(el =>
                                        <tr key={`ht-row-${el}`}>
                                            <td className='first-column'><b>{el}</b></td>
                                            {data[el] && data[el].result.map((item, i) => {
                                                const ht = horizontalTotals[`${el}-${i}`];
                                                const bgColor = ht !== null ? getValueColor(ht, maxHtPerRow[el]) : '#f0f0f0';
                                                return (
                                                    <td key={`ht-${i}`} style={{backgroundColor: bgColor, fontWeight: ht !== null ? 'bold' : 'normal'}}>
                                                        {ht !== null ? (input === "turnover" ? `${ht} €` : ht) : '-'}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })()}
                            </tbody>
                        </table>
                    </div> */}
                </div>
            )}

            {/* Tooltip */}
            {hoveredCell && visualizationMode === 'heatmap' && (
                <div 
                    className="cohort-tooltip"
                    style={{
                        left: hoveredCell.e.pageX - 100,
                        top: hoveredCell.e.pageY - 80
                    }}
                >
                    <div><strong>Période:</strong> {hoveredCell.row}</div>
                    <div><strong>Mois {hoveredCell.col + 1}:</strong> {month[hoveredCell.col]}</div>
                    <div><strong>Valeur:</strong> {hoveredCell.value || 0}</div>
                    <div><strong>Total initial:</strong> {hoveredCell.total || 0}</div>
                    <div><strong>Rétention:</strong> {hoveredCell.total ? Math.round((hoveredCell.value / hoveredCell.total) * 100) : 0}%</div>
                </div>
            )}
        </div>
    );
};

export default CohorteClients;
